import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestSplitOrder } from 'src/app/models/requestSplitOrder';
import { ResponseSplitOrder } from 'src/app/models/responseSplitOrder';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SplitPaymentService {
  splitorder = `${environment.urlglobal_api}/v4/splitpayments/splitorder`;

  constructor(private http: HttpClient) { }

  validateExistsOrder = (token: string): Observable<ResponseSplitOrder> => {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'CheckoutAuthorization': token
      })
    }
    return this.http.get<ResponseSplitOrder>(this.splitorder, headers)
      .pipe(map((response: ResponseSplitOrder) => response));
  }

  generateSplitOrder = (requestBody: RequestSplitOrder): Observable<ResponseSplitOrder> => {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'CheckoutAuthorization': requestBody.token
      })
    }
    return this.http.post<ResponseSplitOrder>(this.splitorder, requestBody, headers)
      .pipe(map((response: ResponseSplitOrder) => response));
  }
}
